<template>
  <div class="header" :class="color?'header-bg':''" @mouseleave="mouseLeave">
    <div class="logo" @click="goto('home')">
      <img :src="logo" />
    </div>
    <div class="navs vertical" :class="isHide?'hide':''">
      <i class="close" @click="setHide"></i>
      <span class="nav" @click="gotoLink(what.dna_explorer)">{{ $t('lang.navs.explores') }}</span>
      <span class="nav" @click="gotoLink(what.dna_wallet)">{{ $t('lang.navs.wallets') }}</span>
      <span class="nav" @click="gotoLink(what.dna_bounty)">{{ $t('lang.navs.bounty') }}</span>
      <div class="nav-list" :class="{show:showMenu=='testnet'}">
        <span
          class="has-arrow down"
          :class="current == 'testnet'?'active':''"
          @click="testnetClick"
        >{{ $t('lang.navs.testnet') }}</span>
        <div class="nav-item">
          <span @click="gotoLink('https://testnet.mvsdna.com')">{{ $t('lang.navs.testnet_explorer') }}</span>
          <span @click="gotoLink('https://dexdev.mvsdna.com')">{{ $t('lang.navs.testnet_dex') }}</span>
          <span @click="gotoLink('https://faucet.mvsdna.com/')">{{ $t('lang.navs.testnet_faucet') }}</span>
        </div>
      </div>
      <div class="nav-list" :class="{show:showMenu=='build'}">
        <span
          class="has-arrow down"
          :class="current == 'build'?'active':''"
          @click="buildClick"
        >{{ $t('lang.navs.build') }}</span>
        <div class="nav-item">
          <span @click="goto('what')">{{ $t('lang.navs.what') }}</span>
          <span @click="goto('helix')">{{ $t('lang.navs.mainnet') }}</span>
          <span @click="goto('development')">{{ $t('lang.navs.development') }}</span>
          <span @click="gotoLink('https://github.com/mvs-org/dna-core/releases/tag/1.0.0')">{{ $t('lang.navs.download') }}</span>
        </div>
      </div>
      <div class="nav-list" :class="{show:showMenu=='community'}">
        <span
          class="has-arrow down"
          :class="current == 'community'?'active':''"
          @click="communityClick"
        >{{ $t('lang.navs.community') }}</span>
        <div class="nav-item">
          <span @click="goto('connect')">{{ $t('lang.navs.connect') }}</span>
          <span @click="goto('ambassador')">{{ $t('lang.navs.global') }}</span>
          <span @click="goto('exchanges')">{{ $t('lang.navs.invest') }}</span>
        </div>
      </div>
      <div class="nav-list" :class="{show:showMenu=='institute'}">
        <span
          class="has-arrow down"
          :class="current == 'institute'?'active':''"
          @click="instituteClick"
        >{{ $t('lang.navs.institute') }}</span>
        <div class="nav-item">
          <span @click="goto('institute')">{{ $t('lang.navs.aboutInstitute') }}</span>
          <span @click="goto('open')">{{ $t('lang.navs.open') }}</span>
          <span @click="goto('fund')">{{ $t('lang.navs.funding') }}</span>
        </div>
      </div>
    </div>
    <div class="open" v-if="isHide" @click="setHide">
      <i></i>
    </div>
  </div>
</template>

<script>
import { what } from "../common/link.js";
export default {
  name: "Header",
  props: {
    active: {
      type: String,
      default: "",
    },
    current: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      logo: "",
      color: false,
      status: this.active,
      isHide: true,
      showMenu: "",
      what,
    };
  },
  created() {
    this.logo = require("../assets/images/logo.png");
    // document.addEventListener("click", (e) => {
    //   if (!this.$el.contains(e.target)) {
    //     this.showMenu = "";
    //   }
    // });
  },

  mounted() {
    this.color = localStorage.getItem("url") == "home" ? false : true;
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    mouseLeave() {
      this.showMenu = "";
    },
    testnetClick() {
      this.dropMenu("testnet");
    },
    buildClick() {
      this.dropMenu("build");
    },
    communityClick() {
      this.dropMenu("community");
    },
    instituteClick() {
      this.dropMenu("institute");
    },
    dropMenu(m) {
      if (m == this.showMenu) {
        this.showMenu = "";
      } else {
        this.showMenu = m;
      }
    },
    setHide() {
      this.isHide = !this.isHide;
    },
    handleScroll() {
      this.showMenu = "";
      // 只在首页处理滚动
      if (localStorage.getItem("url") === "home") {
        let scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
        this.color = scrollTop > 0 ? true : false;
      }
    },
    gotoLink(url) {
      if (!url) {
        this.$message.info({
          message: this.$t("lang.comingsoon"),
          duration: 800,
        });
        return;
      }
      window.open(url, "_blank");
    },
    // 跳转
    goto(url) {
      if (!url) {
        return;
      }
      this.showMenu = "";
      this.status = url;
      switch (url) {
        case "home":
          this.$router.push("/");
          break;
        case "what":
          if (this.$route.name == "BuildWhat") {
            this.$emit("scroll", "");
          } else {
            this.$router.push({ name: "BuildWhat", params: { id: "what" } });
          }
          break;
        case "development":
          this.$router.push({ name: "BuildDevelopment" });
          break;
        case "connect":
          if (this.$route.name == "Connect") {
            this.$emit("scroll", "");
          } else {
            this.$router.push({ name: "Connect", params: { id: "connect" } });
          }
          break;
        case "ambassador":
          if (this.$route.name == "Connect") {
            this.$emit("scroll", "ambassador");
          } else {
            this.$router.push({
              name: "Connect",
              params: { id: "ambassador" },
            });
          }
          break;
        case "exchanges":
          if (this.$route.name == "Connect") {
            this.$emit("scroll", "exchanges");
          } else {
            this.$router.push({ name: "Connect", params: { id: "exchanges" } });
          }
          break;
        case "institute":
          if (this.$route.name == "Institute") {
            this.$emit("scroll", "");
          } else {
            this.$router.push({
              name: "Institute",
              params: { id: "institute" },
            });
          }
          break;
        case "open":
          if (this.$route.name == "Institute") {
            this.$emit("scroll", "open");
          } else {
            this.$router.push({ name: "Institute", params: { id: "open" } });
          }
          break;
        case "fund":
          if (this.$route.name == "Institute") {
            this.$emit("scroll", "fund");
          } else {
            this.$router.push({ name: "Institute", params: { id: "fund" } });
          }
          break;
        case "helix":
          if (this.$route.name == "BuildWhat") {
            this.$emit("scroll", "helix");
          } else {
            this.$router.push({ name: "BuildWhat", params: { id: "helix" } });
          }
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~css/mixins.styl';
@import '~css/varibles.styl';

.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  min-width: 1180px;
  height: 0.96rem;
  z-index: 11;
  center();
  justify-content: space-between;
  padding: 0 3% 0 5%;

  &:hover {
    background-color: $bgColor;
  }

  .logo {
    width: 0.9rem;
    height: 0.45rem;
    overflow: hidden;
    cursor: pointer;

    img {
      width: 100%;
    }
  }

  .navs {
    center();

    .nav {
      height: 0.96rem;
      line-height: 0.96rem;
      padding: 0 0.2rem;
      color: $white;
      font-size: 14px;
      cursor: pointer;
      opacity: 0.8;

      &:hover {
        opacity: 1;
      }
    }

    .nav-list {
      position: relative;

      &:last-child {
        padding-left: 0.2rem;
      }

      &:last-child:before {
        content: '';
        position: absolute;
        top: 50%;
        left: 0.1rem;
        width: 1px;
        height: 0.2rem;
        margin-top: -0.1rem;
        background-color: $white;
        opacity: 0.8;
      }

      .nav-item {
        width: 100%;
        position: absolute;
        left: 0;
        top: 0.96rem;
        display: none;
        background-color: $bgColor;

        >span {
          center();
          justify-content: center;
          text-align: center;
          height: 0.68rem;
          color: $white;
          cursor: pointer;
          opacity: 0.8;
          padding: 0 0.2rem;
          font-size: 14px;

          &:hover, &.active {
            opacity: 1;
            background-color: #002a70;
          }
        }
      }

      >span {
        height: 0.96rem;
        line-height: 0.96rem;
        padding: 0 0.3rem;
        color: $white;
        font-size: 14px;
        cursor: pointer;
        opacity: 0.8;
        transition: All 0.4s ease-in-out;
        -webkit-transition: All 0.4s ease-in-out;
        -moz-transition: All 0.4s ease-in-out;
        -o-transition: All 0.4s ease-in-out;

        &.has-arrow:after {
          content: '';
          display: inline-block;
          width: 12px;
          height: 8px;
          margin-left: 0.11rem;
        }

        &.has-arrow.down:after {
          background: url('../assets/images/arrow-down.png') center center no-repeat;
        }

        &.has-arrow.active {
          opacity: 1;
        }
      }

      &.show {
        > span {
          opacity: 1;
        }

        .nav-item {
          display: block;
        }

        .has-arrow.down:after {
          background: url('../assets/images/arrow-up.png') center center no-repeat;
        }
      }
    }
  }

  .open {
    display: none;
  }
}

.header-bg {
  background-color: $bgColor;
}

minText() {
  color: $dark;
  font-size: 14px;
  height: 40px;
  line-height: 40px;
  padding: 0 20px;
}
@media screen and (max-width: 1024px) {
  .header {
    min-width: 1024px
  }
}

@media screen and (max-width: 768px) {
  .header {
    height: 40px;
    min-width: auto;

    .logo {
      width: 50px;
      height: 25px;
    }

    .vertical {
      position: fixed;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      flex-direction: column;
      background-color: $white;
      align-items: flex-start;

      .close {
        position: absolute;
        top: 20px;
        right: 20px;
        display: block;
        width: 16px;
        height: 16px;
        background: url('../assets/images/error.png') center center no-repeat;
        background-size: 100% auto;
      }

      .nav {
        minText();
      }

      .nav-list {
        .nav-item {
          position: static;
          display: block;
          background-color: $white;

          >span {
            minText();
            justify-content: flex-start;
            padding-left: 40px;
            color: $text;
          }
        }

        >span {
          minText();
        }
      }
    }

    .open {
      display: block;
      width: 40px;
      height: 40px;

      i {
        display: block;
        width: 32px;
        height: 32px;
        margin: 4px auto 0;
        background: url('../assets/images/menu.png') center center no-repeat;
        background-size: 100% auto;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue